import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GroupValidationBloc } from '@kp/auth/group-validation.bloc';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { Status } from '@ktypes/models';
import { Observable, of } from 'rxjs';
import { map, skipWhile, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EligibilityVerificationGuard {
  constructor(
    private _groupValidationBloc: GroupValidationBloc,
    private _onboardingBloc: OnboardingBloc,
    private _router: Router
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this._groupValidationBloc.groupValidationDataStatus$.pipe(
      skipWhile((groupValidationStatus) => {
        return groupValidationStatus?.status !== Status.done;
      }),
      switchMap((groupValidationStatus) => {
        if (!groupValidationStatus) {
          this._onboardingBloc.restoreSavedOnboardingValues();
        }
        if (groupValidationStatus?.data?.eligibilityVerificationTypes?.length > 0) {
          return this._onboardingBloc.eligibilityCandidateStatus$;
        }
        return of(true);
      }),
      map((eligibilityCandidateStatus) => {
        if (eligibilityCandidateStatus === true) {
          return true;
        }
        if (!eligibilityCandidateStatus) {
          this._onboardingBloc.updateEligibilityCandidateFromStorage();
        }
        if (!eligibilityCandidateStatus || !eligibilityCandidateStatus?.data) {
          return this._router.parseUrl('/welcome');
        }
        return true;
      })
    );
  }
}
